// extracted by mini-css-extract-plugin
export var submitWrap = "Form-module--submitWrap--56293";
export var captcha = "Form-module--captcha--1d343";
export var hide = "Form-module--hide--f72ac";
export var column = "Form-module--column--ffdcd";